import { createFileRoute } from '@tanstack/react-router'
import Galeri from '@/modules/galeri'

export const Route = createFileRoute('/_authenticated/galeri/')({
  component: Galeri,
})
